import { render } from "./App.vue?vue&type=template&id=4c515c48"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=4c515c48&lang=css"

import exportComponent from "/Users/gareth/Documents/UW/Global Madison Atlas Final/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__